import { useIsRestoring, useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks";
import { ClassesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi, createOpenApiConfiguration } from "@/lib/utils";

export const useClassGet = (
  classId: number,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    refetchOnMount?: boolean;
  },
) => {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();
  const isRestoring = useIsRestoring();

  const { data, isError, isLoading, isSuccess, isPending, refetch, isFetching, error } = useQuery({
    queryKey: [QueryKeys.Class, classId],
    queryFn: () => {
      if (accessToken) {
        const service = createAuthenticatedApi(ClassesApi, accessToken);
        return service.getClassById({ id: classId, xTenantID: tenantId });
      }
      const service = new ClassesApi(createOpenApiConfiguration());
      return service.getClassById({ id: classId, xTenantID: tenantId });
    },
    enabled: options?.enabled !== false && !!classId && !isRestoring,
    refetchOnWindowFocus: false,
    staleTime: options?.staleTime,
    refetchOnMount: options?.refetchOnMount,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
    isFetching,
    error,
  };
};
